const CLIENT_UUID_STORAGE_KEY = 'piloteer_client_uuid';

const UUID_V4_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const getStoredClientUuid = (): string | null => {
  const clientUuid = localStorage.getItem(CLIENT_UUID_STORAGE_KEY);

  if (!clientUuid) {
    return null;
  }

  if (!UUID_V4_REGEX.test(clientUuid)) {
    localStorage.removeItem(CLIENT_UUID_STORAGE_KEY);
    return null;
  }

  return clientUuid;
};

export const getOrCreateClientUuid = (): string => {
  const existingClientUuid = getStoredClientUuid();

  if (existingClientUuid) {
    return existingClientUuid;
  }

  const clientUuid = crypto.randomUUID();
  localStorage.setItem(CLIENT_UUID_STORAGE_KEY, clientUuid);

  return clientUuid;
};
